/* Brewskin 2026 — announcement bar (v2).
   Scrolls at a set speed in px/s, pauses on hover, focus, the pause button, when off screen or in a hidden tab.
   Reduced motion: arrows step through one message at a time. Taps are sent to Google Tag Manager. */
(function () {
  'use strict';
  if (window.__bsAnn) return;
  window.__bsAnn = true;
  var d = document;
  var KEY = 'bs-ann-paused';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function store(v) { try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (e) { /* storage unavailable */ } }
  function stored() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }

  function setup(bar) {
    var view = bar.querySelector('.bs-ann__viewport');
    var track = bar.querySelector('[data-bs-ann-track]');
    var first = track && track.querySelector('.bs-ann__set');
    var toggle = bar.querySelector('[data-bs-ann-toggle]');
    if (!view || !track || !first) return;

    /* Fill the track with hidden copies so the loop never shows a gap. */
    function layout() {
      Array.prototype.forEach.call(track.querySelectorAll('.bs-ann__set[aria-hidden]'), function (n) { n.remove(); });
      bar.classList.remove('is-still', 'is-running');
      if (bar.classList.contains('bs-ann--one')) return;
      var w = first.getBoundingClientRect().width;
      if (!w) return;
      var copies = Math.max(1, Math.ceil(view.clientWidth / w));
      for (var i = 0; i < copies; i++) {
        var c = first.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(c.querySelectorAll('a,button'), function (el) { el.tabIndex = -1; });
        track.appendChild(c);
      }
      var speed = parseFloat(bar.getAttribute('data-speed')) || 38;
      bar.style.setProperty('--bs-ann-shift', w + 'px');
      bar.style.setProperty('--bs-ann-dur', (w / speed).toFixed(2) + 's');
      if (!(reduce && reduce.matches)) bar.classList.add('is-running');
    }

    function setPaused(p) {
      bar.classList.toggle('is-paused', p);
      if (toggle) {
        toggle.setAttribute('aria-pressed', p ? 'true' : 'false');
        toggle.setAttribute('aria-label', p ? 'Play announcements' : 'Pause announcements');
      }
    }
    setPaused(stored());
    if (toggle) toggle.addEventListener('click', function () {
      var p = !bar.classList.contains('is-paused');
      setPaused(p);
      store(p);
    });

    /* Rest when the bar is off screen or the tab is hidden. */
    var off = false;
    var sync = function () { bar.classList.toggle('is-hidden', off || d.hidden); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { off = !es[0].isIntersecting; sync(); }).observe(bar);
    }
    d.addEventListener('visibilitychange', sync);

    layout();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layout, 150); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(layout);
    if (reduce && reduce.addEventListener) reduce.addEventListener('change', layout);

    /* Reduced motion: one at a time. */
    var slides = bar.querySelector('.bs-ann__slides');
    if (slides) {
      var items = slides.children, i = 0;
      var show = function (n) {
        i = (n + items.length) % items.length;
        Array.prototype.forEach.call(items, function (el, k) {
          el.classList.toggle('is-on', k === i);
          el.setAttribute('aria-hidden', k === i ? 'false' : 'true');
          Array.prototype.forEach.call(el.querySelectorAll('a,button'), function (x) { x.tabIndex = k === i ? 0 : -1; });
        });
      };
      slides.classList.add('is-set');
      show(0);
      bar.addEventListener('click', function (e) {
        var s = e.target.closest('[data-bs-ann-step]');
        if (s) show(i + Number(s.getAttribute('data-bs-ann-step')));
      });
    }

    /* Measure taps. */
    bar.addEventListener('click', function (e) {
      var m = e.target.closest('[data-bs-ann-msg]');
      if (!m) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'announcement_click', announcement_text: (m.textContent || '').trim(), announcement_position: Number(m.getAttribute('data-bs-ann-msg')) });
    });
  }

  function init() { Array.prototype.forEach.call(d.querySelectorAll('[data-bs-ann]'), setup); }
  d.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-bs-ann]'), setup);
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
